import React from 'react'
import $ from 'jquery'

/**
 * Use by wrapping any structure whose *immediate* children you want to animate sequentially:
 * <StaggerGroup interval={170} beforeClassName="before" afterClassName="after">
 *   <div>
 *     <p>Hello!</p>
 *   </div>
 *   <div>
 *     <img src="thing.jpg" />
 *   </div>
 * </StaggerGroup>
 *
 * In the above case we animate in both divs one after the other. They'll both start with ".before" applied, then
 * ".after" will be applied at the interval in ms supplied as prop (and ".before" will be removed)... You should
 * put the transition rule in the ".after" style, and you should basically just think about having ".after" undo
 * what ".before" styled.
 */

import PropTypes from 'prop-types'

import { genericPropType } from 'prop-validators'

class StaggerGroup extends React.Component {
  static propTypes = {
    children: genericPropType,
    initialDelay: PropTypes.number, // time in ms before first animation happens
    interval: PropTypes.number, // pace in ms that animations happens, one after the other
    beforeClassName: PropTypes.string,
    afterClassName: PropTypes.string,
  }

  static defaultProps = {
    initialDelay: 0,
    interval: 400,
  }

  componentDidMount() {
    this.$children = $(this.wrapperEl).children()
    this.setAllBeforeClassNames()
    setTimeout(() => {
      let currentChildIdx = 0
      this.setIntervalID = setInterval(() => {
        this.setAfterClassName(currentChildIdx)
        currentChildIdx = currentChildIdx + 1
      }, this.props.interval)
    }, this.props.initialDelay)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  setAllBeforeClassNames = () => {
    this.$children.addClass(this.props.beforeClassName)
  }

  setAfterClassName = currentChildIdx => {
    const $currentChild = this.$children.eq(currentChildIdx)
    $currentChild.removeClass(this.props.beforeClassName)
    $currentChild.addClass(this.props.afterClassName)
    const lastChildIdx = this.$children.length - 1
    if (currentChildIdx === lastChildIdx) {
      clearInterval(this.setIntervalID)
    }
  }

  render() {
    return <span ref={c => (this.wrapperEl = c)}>{this.props.children}</span>
  }
}

export default StaggerGroup
